import React from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"

import SEO from "../components/seo"
import RenderBlock from "../utils/render-block"

const PageTemplate = ({ data, addVariantToCart }) => {
  const { wpPage } = data

  return (
    <>
      <SEO
        path={`/${wpPage.slug}/`}
        title={wpPage.seo.title}
        description={wpPage.seo.metaDesc}
      />
      {wpPage?.acf?.contentBlocks?.map((el, i) =>
        RenderBlock(el.fieldGroupName, el, i, "page", addVariantToCart)
      )}
    </>
  )
}

PageTemplate.propTypes = {
  data: PropTypes.object,
  addVariantToCart: PropTypes.func.isRequired,
}

export const pageQuery = graphql`
  query($id: String!) {
    wpPage(id: { eq: $id }) {
      slug
      title
      seo {
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          localFile {
            childImageSharp {
              original {
                src
                width
                height
              }
            }
          }
        }
      }
      acf {
        contentBlocks {
          ... on WpPage_Acf_ContentBlocks_BannerHome {
            fieldGroupName
            image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            bannerText
          }
          ... on WpPage_Acf_ContentBlocks_BannerAboutPage {
            bannerHeading
            fieldGroupName
            image {
              altText
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            mobileImage {
              altText
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_BannerShopPage {
            bannerHeading
            fieldGroupName
            image {
              altText
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            mobileImage {
              altText
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_BannerBeBetterPage {
            bannerDescription
            bannerHeading
            fieldGroupName
            image {
              altText
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            mobileImage {
              altText
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_ProductsGlimpse {
            fieldGroupName
            title
          }

          ... on WpPage_Acf_ContentBlocks_RollingMarquee {
            fieldGroupName
            marquee
            backgroundImage {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_EcoConcious {
            description
            fieldGroupName
            heading
            image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            icon {
              localFile {
                publicURL
              }
            }
            imageToTheLeft
            backgroundColor
          }
          ... on WpPage_Acf_ContentBlocks_ShopProductsTagline {
            fieldGroupName
            tagline
            image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_HomepageTestimonials {
            fieldGroupName
            testimonial {
              subject
              review
              rating
              name
              fieldGroupName
              date
            }
          }
          ... on WpPage_Acf_ContentBlocks_Gallery {
            fieldGroupName
            images {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
              altText
            }
            tagline
            linkText
          }
          ... on WpPage_Acf_ContentBlocks_StorySection {
            description
            image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
              altText
            }
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_TitleContent {
            title
            content
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_Title {
            title
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_LogoSocial {
            title
            logos {
              image {
                localFile {
                  childImageSharp {
                    original {
                      src
                    }
                  }
                }
              }
              text
            }
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_Ingredients {
            fieldGroupName
            ingredients {
              ingredientDetail
              ingredientName
              ingredientImage {
                localFile {
                  childImageSharp {
                    original {
                      src
                    }
                  }
                }
                altText
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_FaqAccordion {
            accordion {
              title
              description
              fieldGroupName
            }
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_LeftImageWithPaddingSection {
            description
            fieldGroupName
            title
            image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            points {
              fieldGroupName
              point
            }
          }

          ... on WpPage_Acf_ContentBlocks_ProductList {
            fieldGroupName
            title
          }

          ... on WpPage_Acf_ContentBlocks_SubscriptionList {
            fieldGroupName
            title
          }

          ... on WpPage_Acf_ContentBlocks_RightSvgSection {
            description
            fieldGroupName
            title
          }

          ... on WpPage_Acf_ContentBlocks_BannerBlog {
            fieldGroupName
            text
            image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            imageMobile {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }

          ... on WpPage_Acf_ContentBlocks_PolicyPageContent {
            body
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_ContactForm {
            fieldGroupName
            heading
            subheading
            body
            image {
              altText
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
        }
        fieldGroupName
      }
    }
  }
`

export default PageTemplate
